export const environment = {
  production: false,
  apiUrl: 'https://simple-spa-app.icygrass-ef1002a5.westeurope.azurecontainerapps.io'
};
